import {
    Component, ElementRef, Attribute, AfterViewInit, Output,
    EventEmitter, Input, Renderer2, OnInit, AfterContentInit, ViewEncapsulation, AfterContentChecked, Inject
} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {trigger, state, style, animate, transition} from '@angular/animations';

@Component({
	selector: 'abs-dropdown',
	template: `<span class="selectWrap" *ngIf="isMobile &&(type=='normal' && !helpTextOption)">
     <select (click)="updateTouch()" [attr.id]="drId" [attr.name]="drName" class="awd-select isWrapped" [disabled]="disabled">
        <option *ngIf="(defaultText==undefined)" value="" data-default-placeholder="true" selected="">Select</option>
         <option *ngFor="let d of optionRepeat;let i = index" [value]="i"  [disabled]='d.disabled'  >{{d.text}}</option>
    </select>
    <span [attr.aria-hidden]="true" id="text1">{{currentSelected.text}} <i class="icon-down" [attr.aria-hidden]="true"></i></span>
</span>
<span class="selectWrap" *ngIf="isMobile &&(type=='group' && !optgrpType)">
    <select (click)="updateTouch()" [attr.id]="drId" [attr.name]="drName"  [(ngModel)]="currentSelected.text" class="awd-select isWrapped" [attr.aria-describedby]="'text1'" [attr.aria-labelledby]="'text1'">
        <optgroup [attr.label]="optionRepeat[i].group" *ngFor="let d of optionRepeat; index as i" >
            {{optionRepeat[i].group}}
            <option *ngFor="let item of optionRepeat[i]?.values;let j = index;" [value]="optionRepeat[i].values[j].text" >{{optionRepeat[i].values[j].text}}</option>
        </optgroup>
    </select>
    <span [attr.aria-hidden]="true">
        <span class="module-data" id="text1">{{currentSelected.text}}</span> 
        <i class="icon-down" [attr.aria-hidden]="true"></i>
    </span>
</span>
<span  *ngIf="!isMobile || (isMobile && (type=='image-icons' || type=='no-image-icons' || (type=='normal' && helpTextOption) || (type=='group' && optgrpType)))"  enable-search   [ngClass]="{'selectWrap' : (!optgrpType &&( (type == 'normal' && !helpTextOption) || type == 'group')), 'selectionMenu' : (!optgrpType &&( type == 'no-image-icons' || type == 'image-icons' || (type=='normal' && helpTextOption))) ,'large' : (!optgrpType && (type== 'no-image-icons' || type == 'image-icons')), 'linkSelectionMenu': optgrpType, 'pull-right': pullRight, 'disabled':(type=='normal' && disabled)}">
    <input readonly role="combobox" [attr.id]="drId" [attr.name]="drName" (blur)="onBlur()" #el (keydown)="keyFunction($event,el)" value="{{currentSelected.text}}" [attr.aria-owns]="'listbox'+drId"   [attr.aria-expanded]="toggleFlag"  [disabled]="disabled" type="text" [attr.aria-label]="labelText" [attr.aria-describedby]="drDescribedby" (ngModel)="currentSelected.text" #{{inputName}}="ngModel" class="awd-select isWrapped"   [hidden]="isInputDropdown" [ngClass]="{'active': toggleFlag, 'closed': !toggleFlag, 'large': (type === 'image-icons' || type== 'no-image-icons'),'error': inputName?.touched}" *ngIf="!((optgrpType || type=='no-image-icons' || type=='image-icons' || (type=='normal' && helpTextOption)))"  >
   <button (keydown)="keyFunction($event)" type="button" [disabled]="disabled" [attr.aria-label]="labelText + ' ' +currentSelected?.text"  [attr.aria-expanded]="toggleFlag" [attr.aria-haspopup]="true"  [ngClass]="{'active opened': toggleFlag, 'closed': !toggleFlag, 'large': ((type=='image-icons' || type== 'no-image-icons') && !optgrpType), 'isWrapped':!optgrpType, 'selectMenu': (dropdownType !== 'menu')}" *ngIf="(optgrpType || type=='no-image-icons' || type=='image-icons' || (type=='normal' && helpTextOption))" >
        <img *ngIf="type=='image-icons'" [src]="currentSelected.imgsrc" alt="image cant be loaded"/>
        <span class="module-data">
            {{currentSelected.text}}
            <ng-container *ngIf='!optgrpType && !(type=="normal" && helpTextOption)'>
                <span *ngFor="let currentHelpText of currentSelectedHelpText">{{currentHelpText}}</span>
            </ng-container>
        </span> 
    </button>
    <div  [ngClass]="{'selectWrapper': ((type=='normal' && !helpTextOption )|| (type=='group' && !optgrpType)), 'menuWrapper': (type=='no-image-icons' || type=='image-icons' || (type=='group' && optgrpType) || (type=='normal' && helpTextOption))}">
        <div tabindex="-1" id='listbox{{drId}}' [@expand]="toggleFlag ? 'ddh-collapse-in' : 'ddh-collapse'" *ngIf="type=='normal'" [ngClass]="{'awd-select-list': (type=='normal' && !helpTextOption), 'awd-menu-list':(type=='normal' && helpTextOption)}" >                     
            <ul role="listbox" tabindex="0" [attr.aria-label]="'Choose options'" [ngClass]="{'scrollblur':helpTextOption}" class="optionalClass">
                <li role="option" (keydown)="keyFunction($event)" tabindex="-1" *ngFor="let item of optionRepeat;let i = index"  ngDefaultControl [attr.disabled]="optionRepeat[i].disabled && disabledCheckboxValueOption ? 'disabled': 'none'" [ngClass]="{'menu-list-item': helpTextOption ,'awd-select-list-item': !helpTextOption}" [attr.attrIndex]=i [attr.value]=item  [attr.selected]="((currentSelected.text == item.text) && helpTextOption) ? true : null" [attr.aria-selected]="(currentSelected.text == item.text)"><span class="module-data">{{optionRepeat[i].text}}</span></li>
            </ul>
            <ul role="menu" *ngIf="optCtaButton" class="menu-optinalcta" tabindex="-1" [attr.aria-hidden]="false">
                <li tabindex="-1" role="menuitem" (keydown)="keyFunction($event)" class="menu-list-item">
                    <a [href]="OptionalCtaLink" href="OptionalCtaLink">{{OptionalCtaInnerContent}}</a>
                </li>
            </ul>
        </div>
        <div tabindex="-1" id="listbox{{drId}}" [@expand]="toggleFlag ? 'ddh-collapse-in' : 'ddh-collapse'"  *ngIf="type=='group'" [ngClass]="{'awd-select-list': ((type == 'group' && !optgrpType)), 'awd-menu-list':(type =='group' && optgrpType)}">
             <ul  [ngClass]="{'optionalClass scrollblur': (type =='group' && optgrpType == 'true')}" role="listbox" tabindex="0" [attr.aria-label]="'Choose options'">
                <li tabindex="-1" [attr.attrIndex]=i value=item *ngFor="let item of optionRepeat;let i = index" [ngClass]="{'optgroup-wrapper':(type=='group' && !optgrpType),'menu-groups':(type=='group' && optgrpType)}" >{{optionRepeat[i].group}}
                    <ul tabindex="-1" role="" [ngClass]="{'menu-groupitem':(type=='group' && optgrpType),'optgroup':(type=='group' && !optgrpType)}" [attr.aria-label]="optionRepeat[i].group">
                        <li role="option" (keydown)="keyFunction($event)" tabindex="-1" *ngFor="let itm of optionRepeat[i].values;let p = index" [ngClass]="{'menu-list-item':(type=='group' && optgrpType),'awd-select-list-item':(type=='group' && !optgrpType)}" [attr.aria-selected]="(currentSelected.text == itm.text)" [attr.selected]="(currentSelected.text == itm.text) ? true : null">  
                            <img alt="" [src]="optionRepeat[i].values[p].imgsrc" *ngIf='optgrpType'/>
                            <span class="module-data" [attr.aria-label]="optionRepeat[i].group + ' ' + optionRepeat[i].values[p].text + ' ' + optionRepeat[i].values[p].helpText">{{optionRepeat[i].values[p].text}}</span>
                        </li> 
                    </ul>
                </li>
            </ul>
            <ul role="menu" *ngIf="optCtaButton" class="menu-optinalcta" role="listbox" tabindex="-1" [attr.aria-hidden]="false">
                <li tabindex="-1" role="menuitem" (keydown)="keyFunction($event)" class="menu-list-item">
                    <a [href]="OptionalCtaLink" href="OptionalCtaLink">{{OptionalCtaInnerContent}}</a>
                </li>
            </ul>
        </div>
        <div tabindex="-1" id="listbox{{drId}}" [@expand]="toggleFlag ? 'ddh-collapse-in' : 'ddh-collapse'"  *ngIf="type=='image-icons'" [ngClass]="{ 'awd-menu-list':(type== 'image-icons')}">  
             <ul  role="menu" tabindex="0" [attr.aria-label]="'Choose options'" class="optionalClass" [ngClass]="{'scrollblur':optgrpType}" >
                <li  role="menuitem" (keydown)="keyFunction($event)" tabindex="-1" *ngFor="let item of optionRepeat;let i = index"  ngDefaultControl [ngClass]="{'menu-list-item': (type=='image-icons'|| type== 'no-image-icons')}" [attr.attrIndex]=i [attr.value]=item   [attr.aria-current]="(currentSelected.value == item.value)" [attr.selected]="(currentSelected.value == item.value) ? true : null">
                    <img alt="" [src]="optionRepeat[i].imgsrc">
                    <span class="module-data">{{optionRepeat[i].text}}</span>
                </li>
            </ul>
            <ul role="menu" *ngIf="optCtaButton" class="menu-optinalcta" role="listbox" tabindex="-1" [attr.aria-hidden]="false">
                <li tabindex="-1" role="menuitem" (keydown)="keyFunction($event)" class="menu-list-item">
                    <a [href]="OptionalCtaLink" href="OptionalCtaLink">{{OptionalCtaInnerContent}}</a>
                </li>
            </ul>
        </div>
        <div tabindex="-1" id="listbox{{drId}}" [@expand]="toggleFlag ? 'ddh-collapse-in' : 'ddh-collapse'"  *ngIf="type=='no-image-icons'" [ngClass]="{ 'awd-menu-list':(type=='no-image-icons')}">  
            <ul  role="menu" tabindex="0" [attr.aria-label]="'Choose options'" class="optionalClass">
                <li role="menuitem" (keydown)="keyFunction($event)" tabindex="-1" *ngFor="let item of optionRepeat;let i = index"  ngDefaultControl [ngClass]="{'menu-list-item': (type=='image-icons' || 'no-image-icons')}" [attr.attrIndex]=i [attr.value]=item      [attr.aria-current]="(currentSelected.value == item.value)" [attr.selected]="(currentSelected.value == item.value) ? true : null">
                    <span class="module-data">{{optionRepeat[i].text}}</span>
                </li>
            </ul>
            <ul role="menu" *ngIf="optCtaButton" class="menu-optinalcta" tabindex="-1" [attr.aria-hidden]="false">
                <li tabindex="-1" role="menuitem" (keydown)="keyFunction($event)" class="menu-list-item">
                    <a [href]="OptionalCtaLink" href="OptionalCtaLink">{{OptionalCtaInnerContent}}</a>
                </li>
            </ul>
        </div>
    </div>
    <i class="icon-down" aria-hidden="true"></i>
</span>
`,
	styles: [`select{margin-right:-1;max-width:100%;height:36px;line-height:25px;width:auto;background-color:#fff}.selectWrap.disabled .icon-down{color:#767676}.selectWrap.disabled input.awd-select{z-index:0;padding:10px 45px 10px 15px;text-indent:0}.selectWrap.disabled button.awd-select{z-index:0;text-indent:15px}.selectWrap.disabled:after{color:#5a5a5a;cursor:not-allowed}input.awd-select{background-color:transparent;border:1px solid #d2d2d2;border-radius:6px;-webkit-box-shadow:1px 5px 2px -5px rgba(0,0,0,.15);box-shadow:1px 5px 2px -5px rgba(0,0,0,.15);color:#333;display:block;font-size:1.6rem;height:36px;line-height:0;margin-bottom:0;position:relative;text-align:left;top:0;width:100%;z-index:10;padding:12px 45px 8px 15px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}input.awd-select:focus{border-color:#0568ae!important;text-overflow:ellipsis;padding-right:45px}button.awd-select{background-color:transparent;border:1px solid #d2d2d2;border-radius:6px;-webkit-box-shadow:1px 5px 2px -5px rgba(0,0,0,.15);box-shadow:1px 5px 2px -5px rgba(0,0,0,.15);color:#333;display:block;font-family:Omnes-ATT-W02;font-size:1.6rem;height:36px;line-height:36px;margin-bottom:0;position:relative;text-align:left;top:0;width:100%;z-index:10}button.awd-select:not(.large){text-indent:15px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}button.awd-select img{height:26px;margin-right:7px;margin-top:-10px;position:relative;top:2px;vertical-align:text-bottom}button.awd-select:focus{border-color:#0568ae!important}button.awd-select i{font-size:23px;position:absolute;right:33px;top:5px;z-index:1000}button.awd-select.large{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:60px;line-height:20px;overflow:hidden;padding-left:70px;vertical-align:middle}button.awd-select.large img{height:40px;left:20px;position:absolute;top:20px;width:40px}.selectWrap.large{height:60px}.selectWrap.large .awd-select-list-item{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;height:60px;line-height:20px;overflow:hidden;padding-left:70px;vertical-align:middle}.selectWrap.large .awd-select-list-item img{height:40px;left:20px;position:absolute;width:40px;top:10px}button.awd-select.active{border-radius:6px 6px 0 0}button.awd-select.active:focus{border-color:#d2d2d2!important}input.awd-select.active{border-radius:6px 6px 0 0}input.awd-select.active:focus{border-color:#d2d2d2!important}.selectWrapper{position:relative}span.selectWrap input[readonly]:focus{color:transparent;text-shadow:0 0 0 #000}.isIE.ds2-no-colors .awd-select:focus{outline:transparent dashed 1px}.awd-select-list{-webkit-box-shadow:1px 1px 2px rgba(0,0,0,.15);box-shadow:1px 1px 2px rgba(0,0,0,.15);border-radius:0 0 6px 6px;position:absolute;border:1px solid #d2d2d2;border-top:0;padding:0;background-color:#f2f2f2;z-index:1000;width:100%;max-height:320px;overflow-y:auto}.awd-select-list-item{cursor:pointer;height:100%;min-height:36px;line-height:20px;overflow:hidden;padding:8px 15px;position:relative;z-index:1000}.awd-select-list-item:focus,.awd-select-list-item:hover{cursor:pointer;background-color:#d2d2d2;outline:transparent dashed 1px}.awd-select-list-item img{margin-top:0;margin-right:7px;height:26px;width:26px}.selectWrap{border-radius:6px;position:relative;height:36px;line-height:28px;display:block;margin:0;background:-webkit-gradient(linear,left top,left bottom,from(#fcfcfc),to(#f2f2f2));background:linear-gradient(to bottom,#fcfcfc 0,#f2f2f2 100%);background:-webkit-linear-gradient(top,#fcfcfc 0,#f2f2f2 100%)}.selectWrap:not(.large) .awd-select-list-item:first-child{margin-top:15px}.selectWrap:not(.large) .awd-select-list-item:last-child{margin-bottom:15px}.selectWrap .icon-down{font-size:23px;margin-top:-11px;position:absolute;right:4px;top:50%}.selectWrap+[aria-expanded=true]{padding-bottom:9px;padding-top:20px}.awd-select-list-item[data-hover=true]{background-color:#d2d2d2}span input.awd-select{width:100%;cursor:pointer;text-overflow:ellipsis;padding-right:45px}li.optgroup-wrapper{cursor:default!important;padding:0 15px}li.optgroup-wrapper:first-child{padding-top:10px}li.optgroup-wrapper:hover{background-color:#f2f2f2}ul.optgroup{cursor:pointer!important;margin:0 -15px}ul.optgroup li{padding:9px 0 0 33px}label+.selectWrap{margin-top:4px}.selectorModule{border-radius:6px;position:relative;height:36px;line-height:28px;display:block;margin:0;background:-webkit-gradient(linear,left top,left bottom,from(#fcfcfc),to(#f2f2f2));background:linear-gradient(to bottom,#fcfcfc 0,#f2f2f2 100%);background:-webkit-linear-gradient(top,#fcfcfc 0,#f2f2f2 100%)}.group .selectWrap{margin:0 0 10px}select.awd-select{position:relative;top:0;left:0;font-size:16px;z-index:1010;height:33px;min-width:100%;opacity:.01}select.awd-select>optgroup{padding-left:8px;font-style:normal;margin-top:10px}select.awd-select>optgroup:first-child{margin-top:0}select.awd-select>optgroup>option,select.awd-select>option{padding-left:8px}select.awd-select+span{background:-webkit-gradient(linear,left top,left bottom,from(#fcfcfc),to(#f2f2f2));background:linear-gradient(to bottom,#fcfcfc 0,#f2f2f2 100%);background:-webkit-linear-gradient(top,#fcfcfc 0,#f2f2f2 100%);position:absolute;top:0;left:0;z-index:0;display:block;border:1px solid #d2d2d2;border-radius:6px;height:35px;line-height:0;padding:18px 45px 15px 15px;width:100%;font-size:1.6rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}select.awd-select+span>i{font-size:23px;position:absolute;right:33px;top:5px;z-index:1000}select.awd-select+span>i:before{left:1px;position:absolute;top:-1px}select.awd-select:focus+span{border-color:#0568ae}.isIE select.awd-select+span{line-height:1}.placeholdercolor,[data-default-option=true]{color:#767676!important;font-family:Omnes-ATT-W02-Italic}.filterTank button.awd-select{border-color:#d2d2d2;background-color:#333;color:#333}.filterTank button.awd-select:after{background-color:#fff!important;border-color:#d2d2d2}.utility-bg button.awd-select{border-color:#d2d2d2;background-color:#333;color:#333}.utility-bg button.awd-select:after{background-color:#fff!important;border-color:#d2d2d2}.utility-bg select.awd-select+span{border-color:#d2d2d2;background-color:#333;color:#fff}.utility-bg select.awd-select+span:after{background-color:#fff!important;border-color:#d2d2d2}.utility-bg select.awd-select:focus+span{border-color:#d2d2d2;background-color:#333;color:#fff}.utility-bg select.awd-select:focus+span:after{background-color:#fff!important;border-color:#d2d2d2}.utility-bg select.awd-select:hover+span{border-color:#d2d2d2;background-color:#333;color:#fff}.utility-bg select.awd-select:hover+span:after{background-color:#fff!important;border-color:#d2d2d2}input.awd-select[disabled]{cursor:not-allowed!important;border-color:#d2d2d2;background-color:#d2d2d2;background-image:none;color:#5a5a5a}input.awd-select[disabled]+span{cursor:not-allowed;border-color:#d2d2d2;background-color:#d2d2d2;background-image:none;color:#5a5a5a}button.awd-select[disabled]{cursor:not-allowed!important;border-color:#d2d2d2;background-color:#d2d2d2;background-image:none;color:#5a5a5a}button.awd-select[disabled]:after{background-color:#d2d2d2!important;border-color:#d2d2d2}select.awd-select[disabled]+span{cursor:not-allowed!important;border-color:#d2d2d2;background-color:#d2d2d2;background-image:none;color:#5a5a5a}select.awd-select[disabled]+span:after{background-color:#d2d2d2!important;border-color:#d2d2d2}input.awd-select[disabled=disabled],input.awd-select[disabled=disabled]+span,select.awd-select[disabled=disabled]+span,select.awd-select[disabled]:focus+span,select.awd-select[disabled]:hover+span{cursor:not-allowed;border-color:#d2d2d2;background-color:#d2d2d2;background-image:none;color:#5a5a5a}select.awd-select[disabled=disabled]+span:after{background-color:#d2d2d2!important;border-color:#d2d2d2}select.awd-select[disabled=disabled]:focus+span{cursor:not-allowed;border-color:#d2d2d2;background-color:#d2d2d2;background-image:none;color:#5a5a5a}select.awd-select[disabled=disabled]:focus+span:after{background-color:#d2d2d2!important;border-color:#d2d2d2}select.awd-select[disabled=disabled]:hover+span{cursor:not-allowed;border-color:#d2d2d2;background-color:#d2d2d2;background-image:none;color:#5a5a5a}select.awd-select[disabled=disabled]:hover+span:after{background-color:#d2d2d2!important;border-color:#d2d2d2}.ddexpand-wrapper>h2{margin-bottom:11px}.ddexpand-wrapper>h2+p{margin-bottom:4px}.ddexpand-wrapper .selectWrap+[aria-expanded=true] .form-row{margin-top:11px}.ddexpand-wrapper .selectWrap+[aria-expanded=true] .row+.row .form-row{margin-top:14px}.form-row.error button.awd-select.active:focus,.form-row.error input.awd-select.active:focus{border-color:#cf2a2a!important}.awd-module-list .module-list-item[aria-selected=true]{background-color:#f2f2f2}li.module-list-item[aria-selected=true]:before{font-family:icoControls!important;font-style:normal;font-weight:400;font-variant:normal;margin-right:7px;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;speak:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;content:"\\e907";-webkit-box-sizing:border-box;box-sizing:border-box;display:inline-block;font-size:2em;height:1em;position:absolute;top:20px;right:0;vertical-align:middle;width:1em;color:#007a3e}@media (min-width:768px){.large,span[class*=large]{max-width:370px}}@media (max-width:767px){.selectWrap.large:after{right:5px}.selectWrap.large .awd-select-list-item{padding-right:41px}.selectWrap+div>h4{margin-bottom:0;font-size:16px}}.modalwrapper:not(.modal-docked) .b2b-dropdown-desktop-list{max-height:200px}input.awd-select{-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.selectModule{background-color:transparent;font-family:Omnes-ATT-W02;color:#333;font-size:1.6rem;height:36px;line-height:35px;position:relative;text-align:left;top:0;z-index:10;padding:0;margin:0;cursor:pointer}.b2b-bellyband-link a:after,.breadcrumb>li:after,.checkbox input.indeterminate+.skin:after,.checkbox input:checked+.skin:after,.checkbox input:indeterminate+.skin:after,.close:before,.cssIcon-globe:before,.form-row.error .error-msg:before,.nav-links a:after,.reset-field:before,.selectWrap.large:before,.selectWrap:after,[class*=icon-]{color:#0568ae;display:inline-block;font-family:icoPrimary!important;font-style:normal;font-size:20px;font-weight:400;font-variant:normal;height:1em;margin-right:7px;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;position:relative;speak:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;vertical-align:middle;width:1em}`],
    animations: [
        trigger('expand', [
            state('ddh-collapse', style({
                height: '50px',
                display: 'none'
            })),
            state('ddh-collapse-in', style({
                display: 'block'
            })),
            transition('ddh-collapse => ddh-collapse-in',
                animate('0.3s ease-in-out')
            ),
            transition('ddh-collapse-in => ddh-collapse',
                animate('0.3s ease-in-out')
            )
        ])]
})
export class AbsDropdownComponent implements OnInit, AfterViewInit, AfterContentInit, AfterContentChecked {
    //  keyboard keyCodes
    absUtilitiesConfig = {
        prev: '37',
        up: '38',
        next: '39',
        down: '40',
        enter: '13',
        escape: '27',
        space: '32'
    }
    public focusedElement;
    @Output() public flagTouched: EventEmitter<boolean> = new EventEmitter();
    public blur: boolean;
    public isMobile = /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    public spanObjCount;
    public spanObj;
    @Input('dropdownValue') public dropdownValue;
    @Input() public disabledCheckboxValueOption: any;
    @Input() public disabled;
    @Output() public dropdownValueChange: EventEmitter<any> = new EventEmitter();
    @Input('optionRepeat') public optionRepeat: any;
    @Input() public type: any;
    @Input('dropdownRequired') public dropdownRequired: any;
    @Input('pullRight') public pullRight = false;
    public toggleFlag = false;
    public currentSelected;
    public dropdownType: any;
    public currentSelectedHelpText;
    public ulElem: any;
    public previousElementGroupType;
    public previousElement;
    public searchString = '';
    public searchStringCode = [];
    public searchResult = [];
    public previousKeyPress;
    public dropId;
    public dropName;
    public dropDescribedby;
    public droplabelText;
    public helpLength;
    public ctaOption;
    public docWidth;
    @Input('drId') public drId: any;
    @Input('drName') public drName: any;
    @Input('drDescribedby') public drDescribedby: any;
    @Input('labelText') public labelText = '';
    constructor(
        @Attribute('name') public name,
        @Attribute('optGroup') public optgrpType: any = false,
        @Attribute('optCtaButton') public optCtaButton: boolean = false,
        @Attribute('OptionalCtaLink') public OptionalCtaLink: any,
        @Attribute('OptionalCtaInnerContent') public OptionalCtaInnerContent: string,
        @Inject(ElementRef) public element: ElementRef, 
        @Inject(Renderer2) public renderer: Renderer2,
        @Attribute('id') public id: any,
        @Attribute('helpTextOption') public helpTextOption: any,
        @Attribute('placeHolderText') public defaultText: string,
        @Inject(DomSanitizer) private sanitizer: DomSanitizer
    ) { }
    ngOnInit() {
        this.docWidth = window.screen.width;

        this.renderer.listen(window, 'orientationchange', (e) => {
            this.docWidth = window.screen.width;
        })
        this.renderer.listen(window, 'resize', (e) => {
            this.docWidth = window.screen.width;
        })
        this.flagTouched.emit(false);
        this.blur = false;
        if (this.dropdownValue === undefined) {
            if (this.defaultText === undefined || this.defaultText === null) {
                this.dropdownValue = {
                    'text': 'Select'
                }
            } else {
                this.dropdownValue = {
                    'text': this.defaultText
                }
            }
        }

        this.currentSelected = this.dropdownValue;
        //  it checks if any type is given by the user else it assigns normal type by default
        if (this.type === undefined) {
            this.type = 'normal';
        }
        //  if disable property not given by user then it is set to false
        if (this.disabled === undefined) {
            this.disabled = false;
        }
        // this is for the helpText it is split and assigned to variable currentSelectedHelpText
        if (this.currentSelected.helpText !== undefined) {
            this.currentSelectedHelpText = this.currentSelected.helpText.split(',');
        }
        if (this.helpTextOption === undefined || this.helpTextOption === null) {
            this.helpTextOption = false;
        }
        if (this.optgrpType === undefined || this.optgrpType === null) {
            this.optgrpType = false;
        }
        if (this.optCtaButton === (undefined || null)) {
            this.optCtaButton = false;
        }
        if (this.OptionalCtaLink === null || this.OptionalCtaLink === undefined) {
            const sanitizedUrl = this.sanitizer.bypassSecurityTrustUrl('javascript:void(0)');
            this.OptionalCtaLink = sanitizedUrl
        }
        this.dropId = this.drId;
        this.dropName = this.drName;
        this.dropDescribedby = this.drDescribedby;
        this.droplabelText = this.labelText;
    }
    ngAfterContentInit() {
        if (this.type === 'group') {
            if (this.optgrpType) {
                this.currentSelected = this.currentSelected;
            } else {
                this.currentSelected = this.currentSelected;
            }
        }
    }
   ngAfterContentChecked(){
                if (this.isMobile && this.type === 'normal') {
            const selectElement = this.element.nativeElement.querySelector('select');
            if (selectElement && selectElement.length > 0) {
                const instance = this;
                this.renderer.listen(selectElement, 'change', (event) => {
                    this.dropdownValueChange.emit(instance.optionRepeat[event.target.value]);
                    this.currentSelected = instance.optionRepeat[event.target.value];
                })
            }
        }
        if (this.isMobile && this.type === 'group') {
            const selectElement = this.element.nativeElement.querySelector('select');
            if (selectElement && selectElement.length > 0) {
                this.renderer.listen(selectElement, 'change', (event) => {
                    for (let i = 0; i < this.optionRepeat[i].length; i++) {
                        for (let j = 0; j < this.optionRepeat[i].values.length; j++) {
                            if (this.optionRepeat[i][j] === event.target.value) {
                                this.currentSelected = this.optionRepeat[i][j];
                                this.dropdownValueChange.emit(this.optionRepeat[i][j]);
                            }
                        }
                    }
                })
            }
        }
        if (this.optCtaButton === true && (this.OptionalCtaInnerContent === undefined || this.OptionalCtaInnerContent === null)) {
            this.OptionalCtaInnerContent = 'Optional CTA';
        }
    }
    ngAfterViewInit() {

        // 2 categories need to be same in case of mobile or desktop image-icon & no-image-icon
        if (!this.isMobile || (this.isMobile && (this.type === 'image-icons'
            || this.type === 'no-image-icons' || (this.type === 'normal'
                && this.helpTextOption) || (this.type === 'group' && this.optgrpType)))) {
            //  binding click on the button
            this.renderer.listen(this.element.nativeElement.children[0].children[0], 'click', (event) => {
                this.toggleDropdown();
            });
            //  binding click on document so that all expanded should close when we click outside the dropdown
            if (!this.isMobile) {
                this.renderer.listen(document, 'click', (event) => {
                    this.isElement(this.element.nativeElement, event.target);
                });
            }
            else {
                this.renderer.listen(document, 'touchend', (event) => {
                    this.isElement(this.element.nativeElement, event.target);
                });
            }
            //  setting aria-labeled property on inputElemenet and aria-describedBy
            const inputElem = this.element.nativeElement.querySelector('input');
            this.ulElem = this.element.nativeElement.querySelector('ul');
            if (this.type === 'normal' || this.type === 'image-icons' ||
                this.type === 'no-image-icons') {
                // rendering all elements to assign helpText and images according to category
                for (let i = 0; i < this.optionRepeat.length; i++) {
                    if (this.type === 'image-icons') {
                        if (this.optionRepeat[i].helpText !== undefined) {
                            this.spanObj = this.optionRepeat[i].helpText;
                            const tempSpanObjArray = this.spanObj.split(',');
                            for (let p = 0; p < tempSpanObjArray.length; p++) {
                                const spanElement = '<span>' + tempSpanObjArray[p] + '</span>';
                                this.ulElem.children[i].children[1].innerHTML = this.ulElem.children[i].children[1].innerHTML + spanElement;
                            }
                        }
                    }
                    if (this.type === 'no-image-icons') {
                        if (this.optionRepeat[i].helpText !== undefined) {
                            this.spanObj = this.optionRepeat[i].helpText;
                            const tempSpanObjArray = this.spanObj.split(',');
                            for (let p = 0; p < tempSpanObjArray.length; p++) {
                                const spanElement = '<span>' + tempSpanObjArray[p] + '</span>';
                                this.ulElem.children[i].children[0].innerHTML = this.ulElem.children[i].children[0].innerHTML + spanElement;
                            }
                        }
                    }
                    if (this.type === 'normal' && this.helpTextOption) {
                        if (this.optionRepeat[i].helpText !== undefined) {
                            this.spanObj = this.optionRepeat[i].helpText;
                            const tempSpanObjArray = this.spanObj.split(',');
                            for (let p = 0; p < tempSpanObjArray.length; p++) {
                                const spanElement = '<span>' + tempSpanObjArray[p] + '</span>';
                                this.ulElem.children[i].children[0].innerHTML = this.ulElem.children[i].children[0].innerHTML + spanElement;
                            }
                        }
                    }
                    const insatance = this;
                    this.renderer.listen(this.ulElem.children[i], 'mouseover', (event) => {
                        if (!(event.currentTarget.attributes.getNamedItem('disabled').value === 'disabled')) {
                            event.target.focus();
                        }
                    })
                    // binding click on each list item in the ulElement to select the item which is clicked
                    this.renderer.listen(this.ulElem.children[i], 'click', (event) => {
                        const listLI = this.element.nativeElement.querySelector('ul').children;
                        // to check if the dropdown is not disabled
                        if (event.currentTarget.attributes.getNamedItem('disabled').value === 'disabled') {
                            return;
                        }
                        this.selectDropdownItem(event.currentTarget);
                        // emit the value and update the currentSelected local variable
                        insatance.dropdownValueChange.emit(insatance.optionRepeat[event.currentTarget.attributes.attrindex.value]);
                        insatance.currentSelected = insatance.optionRepeat[event.currentTarget.attributes.attrindex.value];
                        insatance.toggleDropdown();
                    })
                }
            }
        }
        if (this.type === 'group' && !this.isMobile && !this.optgrpType) {
            // binding event on the group type(seperately done beccause it has inner for loop seperately)
            for (let j = 0; j < this.optionRepeat.length; j++) {
                for (let i = 0; i < this.optionRepeat[j].values.length; i++) {
                    this.renderer.listen(this.ulElem.children[j].children[0].children[i], 'click', (event) => {
                        this.selectDropdownItem(event.target);
                        this.toggleDropdown();
                    })
                    if (this.optionRepeat[j].values[i].helpText !== undefined) {
                        this.spanObj = this.optionRepeat[j].values[i].helpText;
                        const tempSpanObjArray = this.spanObj.split(',');
                        for (let p = 0; p < tempSpanObjArray.length; p++) {
                            const spanElement = '<span>' + tempSpanObjArray[p] + '</span>';
                            this.ulElem.children[j].children[0].children[i].children[0].innerHTML = this.ulElem.children[j].children[0].children[i].children[0].innerHTML + spanElement;
                        }
                    }
                }
            }
            if (this.optCtaButton) {
                this.element.nativeElement.querySelectorAll('.menu-optinalcta')[0].children[0].children[0].innerHTML = this.OptionalCtaInnerContent;
            }
        }
        if (this.type === 'group' && this.optgrpType) {
            // binding event on the group type(seperately done beccause it has inner for loop seperately)
            for (let j = 0; j < this.optionRepeat.length; j++) {
                for (let i = 0; i < this.optionRepeat[j].values.length; i++) {
                    this.renderer.listen(this.ulElem.children[j].children[0].children[i], 'click', (event) => {
                        this.selectDropdownItem(event.currentTarget);
                        this.toggleDropdown();
                    })
                    if (this.optionRepeat[j].values[i].helpText !== undefined) {
                        this.spanObj = this.optionRepeat[j].values[i].helpText;
                        const tempSpanObjArray = this.spanObj.split(',');
                        for (let p = 0; p < tempSpanObjArray.length; p++) {
                            const spanElement = '<span>' + tempSpanObjArray[p] + '</span>';
                            this.ulElem.children[j].children[0].children[i].children[1].innerHTML = this.ulElem.children[j].children[0].children[i].children[1].innerHTML + spanElement;
                        }
                    }
                }
            }
            if (this.optCtaButton) {
                this.element.nativeElement.querySelectorAll('.menu-optinalcta')[0].children[0].children[0].innerHTML = this.OptionalCtaInnerContent;
            }
        }
    }
    // To check during document click that target is not any dropdown list
    public isElement(targetElement, currentElemenet) {

        if (targetElement === currentElemenet) {
            return true;
        } else {
            if (currentElemenet.parentElement === null) {
                this.toggleFlag = false;
                if (this.blur) {
                    this.flagTouched.emit(true);
                }
                return;
            }
            this.isElement(targetElement, currentElemenet.parentElement);
        }
    }
    public selectDropdownItem(target) {
        // handlue updates and toggling of drioDown i.e it should close after selection
        if (!this.disabled) {
            this.updateDropdownValue(target);
        }
    }
    public onBlur() {
        this.blur = true;
    }

    public updateDropdownValue(target) {

        if (target === undefined) {
            return;
        }
        // it checks for target li disable class
        if (target.hasAttribute('disabled') && target.attributes.getNamedItem('disabled').value === 'disabled') {
            return;
        }
        if (this.type === 'normal' || this.type === 'image-icons' || this.type === 'no-image-icons') {
            // updates the currentSelected value based on index selected
            this.currentSelected = this.optionRepeat[target.attributes.attrIndex.value];
            this.dropdownValueChange.emit(this.currentSelected);
            if (this.currentSelected.helpText !== undefined) {
                // update the current selected helpText if we have any
                this.spanObj = this.currentSelected.helpText;
                this.currentSelectedHelpText = this.spanObj.split(',');
            }
        }
        if (this.type === 'group') {
            if (this.optgrpType) {
                while (target.parentElement.nodeName === 'SPAN') {
                    target = target.parentElement;
                }
            }
            for (let j = 0; j < this.optionRepeat.length; j++) {
                for (let i = 0; i < this.optionRepeat[j].values.length; i++) {

                    let targetText;
                    if (!this.optgrpType) {
                        if (target.children.length > 1) {
                            let length = 0;
                            for (let count = 0; count < target.children.length; count++) {
                                length = length + target.children[count].innerText.length;
                            }
                            targetText = target.innerText.substring(0, target.innerText.length - length - (target.children.length + 1));
                        } else {
                            targetText = target.innerText.replace(/\s+/g, ' ').trim();
                        }
                    }
                    if (this.optgrpType) {
                        if (target.children[1].children.length > 0) {
                            let length = 0;
                            for (let count = 0; count < target.children[1].children.length; count++) {
                                length = length + target.children[1].children[count].innerText.length;
                            }
                            targetText = target.innerText.replace(/\s/g, '').substring(0, target.innerText.replace(/\s/g, '').length - length);
                        } else {
                            targetText = target.innerText;
                        }
                    }
                    // update value of current selected and emit based on target innerText
                    if (this.optionRepeat[j].values[i].text.replace(/\s/g, '') === targetText.replace(/\s/g, '').trim()) {
                        this.dropdownValueChange.emit(this.optionRepeat[j].values[i]);
                        this.currentSelected = this.optionRepeat[j].values[i];
                        if (this.type === 'group' && this.optgrpType) {
                            this.previousElement = this.currentSelected.text + this.currentSelected.helpText
                        } else {
                            this.previousElement = this.currentSelected.text;
                        }
                    }
                }
            }
        }
    }
    public toggleDropdown() {
        let currentSelectedHelpText;
        if (this.element.nativeElement.querySelectorAll('.awd-menu-list')[0] !== undefined && !this.toggleFlag) {
            this.fixUpCSS(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0].parentElement, { 'left': '0' + 'px' })
        }
        const instance = this;
        if (this.currentSelected.helpText !== undefined) {
            currentSelectedHelpText = this.currentSelected.helpText.replace(',', ' ');
        }
        // basic toggleing functionality which updates the toggleFlag value
        if (!this.disabled) {
            if (this.toggleFlag !== undefined) {
                this.toggleFlag = !this.toggleFlag;
                if (this.toggleFlag === false && this.blur === true) {
                    this.flagTouched.emit(true);
                }
                if (!this.toggleFlag) {
                    this.previousElement = this.currentSelected.text;
                }
            }
        }
        setTimeout(() => {
            if (instance.toggleFlag) {
                for (let i = 0; i < instance.ulElem.children.length; i++) {
                    if ((this.type === 'normal' && !this.helpTextOption) || (this.type === 'group' && !this.optgrpType)) {
                        if (instance.ulElem.children[i].innerText === instance.currentSelected.text) {
                            instance.ulElem.children[i].focus();
                        }
                        if ('Select' === instance.currentSelected.text || this.defaultText === instance.currentSelected.text) {
                            if (this.type === 'normal') {
                                var itemIndex = 0;
                                while (instance.ulElem.children[itemIndex].attributes.getNamedItem('disabled').value === 'disabled') {
                                    itemIndex++;
                                }
                                instance.ulElem.children[itemIndex].focus();
                            } else if (this.type === 'group') {
                                var itemIndex = 0;
                                while (instance.ulElem.children[0].children[0].children[itemIndex].hasAttribute('disabled') && instance.ulElem.children[0].children[0].children[itemIndex].attributes.getNamedItem('disabled').value === 'disabled') {
                                    itemIndex++;
                                }
                                instance.ulElem.children[0].children[0].children[itemIndex].focus();
                            }
                        }

                    }
                    if (this.type === 'group' && this.optgrpType) {
                        for (let j = 0; j < instance.ulElem.children[i].children[0].children.length; j++) {
                            if (instance.ulElem.children[i].children[0].children[j].innerText.replace(/\s+/g, ' ').trim() === instance.currentSelected.text + ' ' + currentSelectedHelpText) {
                                instance.ulElem.children[i].children[0].children[j].focus();
                            }
                        }
                    } else {
                        if (instance.ulElem.children[i].innerText.replace(/\s+/g, ' ').trim() === (instance.currentSelected.text + ' ' + currentSelectedHelpText)) {
                            instance.ulElem.children[i].focus();
                        }
                    }
                }
            } else {
                // When closing normal dropdown set focus to input --***
                if ((instance.type === 'normal' && instance.helpTextOption !== true) || (instance.type === 'group' && !instance.optgrpType)) {
                    instance.element.nativeElement.querySelector('input').focus();
                } else {
                    instance.element.nativeElement.querySelector('button').focus();
                }
            }
        });
        setTimeout(() => {
            if (this.toggleFlag && ((this.type === 'normal' && this.helpTextOption)
                || this.type === 'no-image-icons' || this.type === 'image-icons'
                || (this.type === 'group') && this.optgrpType)) {
                this.scrollToViewVertical(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0]);
                setTimeout(() => {
                    this.scrollToView(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0], 40);
                }, 300)
            }
            if (this.toggleFlag && ((this.type === 'normal' && !this.helpTextOption) || (this.type === 'group') && !this.optgrpType)) {
                this.scrollToViewVertical(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0]);
                setTimeout(() => {
                    this.scrollToView(this.element.nativeElement.querySelectorAll('.awd-select-list')[0], 40);
                }, 300)
            }
        });
        if (this.optgrpType) {
            const wrapperWidth = this.element.nativeElement.children[0].querySelector('.awd-menu-list').offsetWidth,
                left = this.element.nativeElement.children[0].querySelector('.awd-menu-list').getBoundingClientRect().left,
                //  docWidth = window.innerWidth;
                docWidth = document.documentElement.clientWidth;
            if (!(docWidth - left >= wrapperWidth)) {
                const targetLeft = docWidth - left - wrapperWidth - 5;
                this.appendCaretPositionStyle(Math.abs(targetLeft));
            } else {
                this.appendCaretPositionStyle(undefined);
            }
        }
    }

    public keyFunction(event, el) {
        // key functionality in dropDown
        let ArrayOfLi = [];
        if (this.type === 'group') {
            if (event.target.type === 'button') {
                let ArrayOfOuterLi = event.target.parentElement.querySelectorAll('li');
                for (let i = 1; i < ArrayOfOuterLi.length; i++) {
                    if (ArrayOfOuterLi[i].className.indexOf('optgroup-wrapper') == -1 &&
                        ArrayOfOuterLi[i].className.indexOf('menu-groups') == -1) {
                        ArrayOfLi.push(ArrayOfOuterLi[i]);
                    }
                }
            } else {
                let ArrayOfOuterLi = event.target.parentElement.parentElement.parentElement.querySelectorAll('li');
                for (let i = 1; i < ArrayOfOuterLi.length; i++) {
                    if (ArrayOfOuterLi[i].className.indexOf('optgroup-wrapper') === -1
                        && ArrayOfOuterLi[i].className.indexOf('menu-groups') === -1) {
                        ArrayOfLi.push(ArrayOfOuterLi[i]);
                    }
                }
            }
        } else {
            if (event.target.parentElement.parentElement.className.indexOf('menu-optinalcta') > -1) {
                ArrayOfLi = event.target.parentElement.parentElement.parentElement.children[0].querySelectorAll('li');
            } else {
                ArrayOfLi = event.target.parentElement.querySelectorAll('li');
            }
        }
        this.keyDownHandler(event, ArrayOfLi, el);
    }

    public keyDownHandler(ev, ArrayOfLi, el) {
        // Based on keyCode different functions are called on the LiItems
        if (ev.keyCode) {
            // alt + down arrow should open the dropdown
            // if (ev.altKey === true && ev.keyCode === 40) {
            if (el && el.classList.contains('closed') && ev.keyCode === 40) {
                if (!this.toggleFlag) {
                    this.toggleDropdown();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            } else if (ev.keyCode === 27 || (ev.altKey === true && ev.keyCode === 38) || ev.keyCode === 9) {
                if (this.toggleFlag) {
                    this.toggleDropdown();
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            } else if (this.absUtilitiesConfig.up && this.absUtilitiesConfig.up.indexOf(ev.keyCode.toString()) > -1) {
                // move to the previous item in list if upKey is pressed
                ev.target.blur();
                this.movePreDropdownValue(ev, ArrayOfLi);
                ev.preventDefault();
                ev.stopPropagation();
            } else if (this.absUtilitiesConfig.down && this.absUtilitiesConfig.down.indexOf(ev.keyCode.toString()) > -1) {
                // move to the next item in list if downKey is pressed
                ev.target.blur();
                this.moveNextDropdownValue(ArrayOfLi);
                ev.preventDefault();
                ev.stopPropagation();
            } else if (this.absUtilitiesConfig.enter && this.absUtilitiesConfig.enter.indexOf(ev.keyCode.toString()) > -1) {
                ev.preventDefault();
                ev.stopPropagation();
                if (this.toggleFlag) {
                    this.selectDropdownItem(ev.target);
                    if ((this.type === 'normal' && !this.helpTextOption) || (this.type === 'group' && !this.optgrpType)) {
                        this.toggleDropdown();
                    }

                }
                if (this.type === 'no-image-icons' || this.type === 'image-icons' ||
                    (this.type === 'normal' && this.helpTextOption) ||
                    (this.type === 'group' && this.optgrpType)) {
                    this.toggleDropdown();
                    this.scrollToViewVertical(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0]);
                    setTimeout(() => {
                        this.scrollToView(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0], 40);
                    }, 300)
                }

            } else if (this.absUtilitiesConfig.space && this.absUtilitiesConfig.space.indexOf(ev.keyCode.toString()) > -1) {
                ev.preventDefault();
                ev.stopPropagation();
                if (this.toggleFlag) {
                    this.selectDropdownItem(ev.target);
                    if ((this.type === 'normal' && !this.helpTextOption) || (this.type === 'group' && !this.optgrpType)) {
                        this.toggleDropdown();
                    }

                }
                if (this.type === 'no-image-icons' || this.type === 'image-icons' ||
                    (this.type === 'normal' && this.helpTextOption) ||
                    (this.type === 'group' && this.optgrpType)) {
                    var instance = this;
                    this.toggleDropdown();
                    this.scrollToViewVertical(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0]);
                    setTimeout(() => {
                        instance.scrollToView(this.element.nativeElement.querySelectorAll('.awd-menu-list')[0], 40)
                    }, 300);
                }

            } else if (ev.keyCode >= 48 && ev.keyCode <= 105) {
                if (this.previousKeyPress === ev.keyCode) {
                    for (let q = 0; q < this.searchResult.length; q++) {
                        if (this.type !== 'group') {
                            if (this.currentSelected === this.optionRepeat[this.searchResult[q]]) {
                                if (ArrayOfLi[this.searchResult[q]] !== undefined) {
                                    if (this.currentSelected !== this.optionRepeat[this.searchResult[this.searchResult.length - 1]]) {
                                        this.updateDropdownValue(ArrayOfLi[this.searchResult[q + 1]]);
                                        ArrayOfLi[this.searchResult[q + 1]].focus();
                                    } else {
                                        this.updateDropdownValue(ArrayOfLi[this.searchResult[0]]);
                                        ArrayOfLi[this.searchResult[0]].focus();
                                    }

                                }
                                return;
                            }
                        } else {
                            for (let w = 0; w < this.optionRepeat.length; w++) {
                                if (this.currentSelected === this.optionRepeat[q].values[this.searchResult[q]]) {
                                    if (ArrayOfLi[this.searchResult[q]] !== undefined) {
                                        if (this.currentSelected !== this.optionRepeat[this.searchResult[this.searchResult.length - 1]]) {
                                            this.updateDropdownValue(ArrayOfLi[this.searchResult[q + 1]]);
                                            ArrayOfLi[this.searchResult[q + 1]].focus();
                                        } else {
                                            this.updateDropdownValue(ArrayOfLi[this.searchResult[0]]);
                                            ArrayOfLi[this.searchResult[0]].focus();
                                        }

                                    }
                                    return;
                                }
                            }
                        }
                    }
                } else {
                    this.searchStringCode.push(ev.keyCode);
                    this.searchElement(this.searchStringCode);
                    this.previousKeyPress = ev.keyCode
                    this.startTimer(1000);
                    this.updateDropdownValue(ArrayOfLi[this.searchResult[0]]);
                    if (ArrayOfLi[this.searchResult[0]] !== undefined) {
                        ArrayOfLi[this.searchResult[0]].focus();
                    }
                    ev.preventDefault();
                    ev.stopPropagation();
                }
            } else if (this.absUtilitiesConfig.escape && this.absUtilitiesConfig.escape.indexOf(ev.keyCode.toString()) > -1) {
                if (this.toggleFlag === true) {
                    this.toggleDropdown();
                }
            }
            setTimeout(() => {
                const instance = this;
                if (ev.keyCode === 9 || (ev.keyCode === 9 && ev.shiftKey)) {
                    if (instance.blur === true) {
                        instance.flagTouched.emit(true);
                    }
                }
            });
        }
    }
    public moveNextDropdownValue(ArrayOfLi) {
        this.ctaOption = this.element.nativeElement.querySelector('ul.menu-optinalcta li');

        if (this.focusedElement === undefined) {
            this.focusedElement = this.currentSelected.text;
        } else {
            if (this.previousElement !== undefined) {
                this.focusedElement = this.previousElement;
            }
        }
        const lengthOfArray = ArrayOfLi.length;
        for (let i = 0; i < ArrayOfLi.length; i++) {
            let flag = false;
            if (this.type === 'image-icons' || this.type === 'no-image-icons' ||
                (this.type === 'group' && this.optgrpType) || (this.type === 'normal'
                    && this.helpTextOption)) {
                if (ArrayOfLi[i].innerText.match(this.focusedElement) != null) {
                    flag = true;
                };
            } else {
                // add case where defaultText attribute is used
                // (special type of dropdown that doesn't show default value in option list)
                if (((ArrayOfLi[i].textContent.replace(/\s+/g, ' ').trim()) === this.focusedElement) ||
                    ('Select' === this.focusedElement) ||
                    this.defaultText === this.focusedElement) {
                    flag = true;
                };

            }
            if (flag === false) {
                if (this.ctaOption !== null) {
                    if (this.focusedElement === this.ctaOption.innerText) {
                        this.ctaOption.querySelector('a').focus();
                        return;
                    }
                }
            }
            if (flag === true) {
                if (this.type !== 'group') {
                    let flag1 = true;
                    if (this.type === 'image-icons' || this.type === 'no-image-icons' ||
                        (this.type === 'normal' && this.helpTextOption)) {
                        if (ArrayOfLi[i].attributes.attrindex.value == lengthOfArray - 1) {
                            flag1 = false;
                        }
                    } else {
                        // add case where defaultText attribute is used
                        // (special type of dropdown that doesn't show default value in option list)
                        if (ArrayOfLi[i].attributes.attrindex.value === (lengthOfArray - 1).toString()) {
                            flag1 = false;
                        }
                    }
                    if (!flag1) {
                        if (this.optionRepeat[this.optionRepeat.length - 1].helpText !== (null || undefined)) {
                            this.helpLength = this.optionRepeat[this.optionRepeat.length - 1].helpText.length;
                            let noOfSpan = this.optionRepeat[this.optionRepeat.length - 1].helpText.split(',').length
                            this.focusedElement = this.focusedElement.substring(0, this.focusedElement.length - this.helpLength - noOfSpan)
                        }
                        if (this.ctaOption != null) {
                            this.ctaOption.querySelector('a').focus();
                            this.previousElement = this.ctaOption.innerText;
                        } else if ((this.focusedElement).replace(/\s+/g, ' ').trim() === (this.optionRepeat[this.optionRepeat.length - 1].text.replace(/\s+/g, ' ').trim())) {
                            i = this.optionRepeat.length - 2;
                            let liSelected = ArrayOfLi[i + 1];
                            while (this.checkDisable(liSelected)) {
                                if (i + 1 === this.optionRepeat.length - 1) {
                                    break;
                                }
                                i++;
                                liSelected = ArrayOfLi[i + 1];

                            }
                            if (this.toggleFlag) {
                                liSelected.focus();
                            }
                            this.previousElement = liSelected.innerText
                        }

                        if (!this.toggleFlag) {
                            if ((this.type === 'normal' && !this.helpTextOption) && i === this.optionRepeat.length - 1) {
                                this.currentSelected = this.optionRepeat[i];
                                this.previousElement = this.currentSelected.text;
                                if (this.currentSelected.helpText !== undefined) {
                                    this.spanObj = this.currentSelected.helpText;
                                    this.currentSelectedHelpText = this.spanObj.split(',');
                                }
                                this.dropdownValueChange.emit(this.currentSelected);
                            }

                            if (this.type === 'image-icons' || this.type === 'no-image-icons' ||
                                (this.type === 'normal' && this.helpTextOption) ||
                                (this.type === 'group' && this.optgrpType)) {
                                this.element.nativeElement.querySelector('button').focus();
                            } else {
                                this.element.nativeElement.querySelector('input').focus();
                            }
                        }
                        return;
                    }
                    if (flag1 && i !== this.optionRepeat.length - 1) {
                        let liSelected = ArrayOfLi[i + 1];
                        this.previousElement = ArrayOfLi[i];
                        while (this.checkDisable(liSelected)) {
                            if (i + 1 === this.optionRepeat.length - 1) {
                                liSelected = ArrayOfLi[i];
                                break;
                            }
                            i++;
                            liSelected = ArrayOfLi[i + 1];
                        }
                        liSelected.focus();
                        this.previousElement = liSelected.innerText;
                        if (!this.toggleFlag) {
                            if (this.currentSelected.text === 'Select' || this.currentSelected.text == this.defaultText) {
                                for (let j = this.optionRepeat.length - 1; j >= 0; j--) {
                                    if (!this.optionRepeat[j].disabled) {
                                        this.currentSelected = this.optionRepeat[j];
                                    }
                                }
                            } else {
                                if (this.optionRepeat[i + 1].disabled) {
                                    i++;
                                }
                                if (i !== this.optionRepeat.length - 1) {
                                    this.currentSelected = this.optionRepeat[i + 1];
                                }
                            }

                            this.previousElement = this.currentSelected.text;
                            if (this.currentSelected.helpText !== undefined) {
                                this.spanObj = this.currentSelected.helpText;
                                this.currentSelectedHelpText = this.spanObj.split(',');
                            }
                            if (i < this.optionRepeat.length - 1 && !this.optionRepeat[i + 1].disabled) {
                                this.dropdownValueChange.emit(this.currentSelected);
                            }
                            if (this.type === 'image-icons' || this.type === 'no-image-icons' ||
                                (this.type === 'normal' && this.helpTextOption) || (this.type === 'group' && this.optgrpType)) {
                                this.element.nativeElement.querySelector('button').focus();
                            } else {
                                this.element.nativeElement.querySelector('input').focus();
                            }
                        }
                        return;
                    }
                    if (flag1 && i === this.optionRepeat.length - 1) {
                        if (this.type === 'image-icons' || this.type === 'no-image-icons'
                            || (this.type === 'normal' && this.helpTextOption) || (this.type === 'group' && this.optgrpType)) {
                            this.element.nativeElement.querySelector('button').focus();
                        } else {
                            this.element.nativeElement.querySelector('input').focus();
                        }
                    }

                } else if (this.type === 'group' && !this.optgrpType) {
                    const outerLoop = this.optionRepeat.length;
                    const innerLoop = this.optionRepeat[outerLoop - 1].values.length;
                    if (ArrayOfLi[i].innerText.replace(/\s+/g, ' ').trim() !== this.optionRepeat[outerLoop - 1].values[innerLoop - 1].text) {
                        this.previousElement = ArrayOfLi[i];
                        //                        if (this.currentSelected.text === "Select") {
                        //                            i = -1
                        //                        }
                        let liSelected = ArrayOfLi[i + 1];
                        liSelected.focus();
                        this.previousElement = liSelected.innerText.replace(/\s+/g, ' ').trim();
                        if (!this.toggleFlag) {
                            for (let k = 0; k < this.optionRepeat.length; k++) {
                                for (let j = 0; j < this.optionRepeat[k].values.length; j++) {
                                    if (liSelected.innerText.replace(/\s+/g, ' ').trim() === this.optionRepeat[k].values[j].text) {
                                        //                                        if (this.currentSelected.text === "Select") {
                                        //                                            this.currentSelected = this.optionRepeat[0].values[0];
                                        //                                        }
                                        //                                        else {
                                        this.currentSelected = this.optionRepeat[k].values[j];
                                        //                                        }
                                        this.currentSelected = this.optionRepeat[k].values[j];
                                        this.previousElement = this.currentSelected.text;
                                        if (!this.optionRepeat[k].values[j].disabled) {
                                            this.dropdownValueChange.emit(this.currentSelected);
                                            this.element.nativeElement.querySelector('input').focus();
                                        }
                                    }
                                }
                            }
                        }
                        return;
                    } else if (ArrayOfLi[i].innerText.replace(/\s+/g, ' ').trim() === this.optionRepeat[outerLoop - 1].values[innerLoop - 1].text) {
                        this.previousElement = ArrayOfLi[i];
                        i = i - 1;
                        let liSelected = ArrayOfLi[i + 1];
                        liSelected.focus();
                        this.previousElement = liSelected.innerText.replace(/\s+/g, ' ').trim();
                        if (!this.toggleFlag) {
                            for (let k = 0; k < this.optionRepeat.length; k++) {
                                for (let j = 0; j < this.optionRepeat[k].values.length; j++) {
                                    if (liSelected.innerText.replace(/\s+/g, ' ').trim() === this.optionRepeat[k].values[j].text) {
                                        this.currentSelected = this.optionRepeat[k].values[j];
                                        this.previousElement = this.currentSelected.text;
                                        if (!this.optionRepeat[k].values[j].disabled) {
                                            this.dropdownValueChange.emit(this.currentSelected);
                                            this.element.nativeElement.querySelector('input').focus();
                                        }
                                    }
                                }
                            }
                        }
                        return;
                    }
                } else if (this.type === 'group' && this.optgrpType) {
                    let LiInnerText;
                    const outerLoop = this.optionRepeat.length;
                    const innerLoop = this.optionRepeat[outerLoop - 1].values.length;
                    let length = 0
                    for (let count = 0; count < ArrayOfLi[i].querySelectorAll('span').length; count++) {
                        if (count === 0) {
                            continue;
                        }
                        length = length + ArrayOfLi[i].querySelectorAll('span')[count].innerText.length;
                    }
                    if (ArrayOfLi[i].querySelectorAll('span').length > 0) {
                        let ArrayOfLiText = ArrayOfLi[i].querySelectorAll('span')[0].innerText.substring(0, ArrayOfLi[i].querySelectorAll('span')[0].innerText.length - length);
                        if (ArrayOfLiText.match(this.optionRepeat[outerLoop - 1].values[innerLoop - 1].text) == null) {
                            this.previousElement = ArrayOfLi[i];
                            let liSelected = ArrayOfLi[i + 1];
                            liSelected.focus();
                            this.previousElement = liSelected.innerText
                            let length2 = 0;
                            for (let count = 0; count < liSelected.querySelectorAll('span').length; count++) {
                                if (count === 0) {
                                    continue;
                                }
                                length2 = length2 + liSelected.querySelectorAll('span')[count].innerText.length;
                            }
                            LiInnerText = liSelected.querySelectorAll('span')[0].innerText.substring(0, liSelected.querySelectorAll('span')[0].innerText.length - length2)
                            if (!this.toggleFlag) {
                                for (let k = 0; k < this.optionRepeat.length; k++) {
                                    for (let j = 0; j < this.optionRepeat[k].values.length; j++) {
                                        if (LiInnerText.replace(/\s+/g, ' ').trim() === this.optionRepeat[k].values[j].text) {
                                            this.currentSelected = this.optionRepeat[k].values[j];
                                            this.previousElement = this.currentSelected.text
                                            if (!this.optionRepeat[k].values[j].disabled) {
                                                this.dropdownValueChange.emit(this.currentSelected);
                                                this.element.nativeElement.querySelector('button').focus();
                                            }
                                        }
                                    }
                                }
                            }
                            return;
                        } else {
                            this.previousElement = ArrayOfLi[i];
                            if (this.ctaOption != null) {
                                this.ctaOption.querySelector('a').focus();
                                this.previousElement = this.ctaOption.innerText;
                            }
                            if (!this.toggleFlag) {
                                this.currentSelected = this.optionRepeat[this.optionRepeat.length - 1].values[this.optionRepeat[this.optionRepeat.length - 1].values.length - 1];
                                this.previousElement = this.currentSelected.text
                                if (!this.optionRepeat[this.optionRepeat.length - 1].values[this.optionRepeat[this.optionRepeat.length - 1].values.length - 1].disabled) {
                                    this.dropdownValueChange.emit(this.currentSelected);
                                    this.element.nativeElement.querySelector('button').focus();
                                }
                            }
                            return;
                        }
                    } else {
                        if (this.ctaOption != null) {
                            this.previousElement = ArrayOfLi[i];
                            this.ctaOption.querySelector('a').focus();
                            this.previousElement = this.ctaOption.innerText;
                        }
                    }
                }
            }
        }
    }
    public checkDisable(liSelected) {
        // to check the item passed has class disalbled or not
        if (liSelected !== undefined && liSelected.hasAttribute('disabled') && liSelected.attributes.getNamedItem('disabled').value === 'disabled') {
            return true;
        } else {
            return false;
        }
    }
    public movePreDropdownValue(ev, ArrayOfLi) {
        let splCase = false;
        if (this.focusedElement === undefined) {
            this.focusedElement = this.currentSelected.text;
        } else {
            this.focusedElement = this.previousElement;
        }
        for (let i = 0; i < ArrayOfLi.length; i++) {
            let flag = false;
            if (this.type === 'image-icons' || this.type === 'no-image-icons' || (this.type === 'normal' && this.helpTextOption)) {
                for (let x = 0; x < this.optionRepeat.length; x++) {
                    if (this.optionRepeat[x].value === this.focusedElement.replace(/\s+/g, ' ').trim()) {
                        if (ArrayOfLi[i].attributes.attrindex.value == x) {
                            flag = true;
                        }
                    }
                }
                if (flag === false) {
                    if (this.ctaOption != null) {
                        if (this.focusedElement == this.ctaOption.innerText) {
                            this.focusedElement = this.optionRepeat[this.optionRepeat.length - 1].text;
                            i = this.optionRepeat.length - 1;
                            splCase = true;
                            flag = true;
                        }
                    }
                }
            }
            if (this.type === 'group' && this.optgrpType) {
                for (let x = 0; x < this.optionRepeat.length; x++) {
                    for (let y = 0; y < this.optionRepeat[x].values.length; y++) {
                        if (ArrayOfLi[i].innerText.match(this.focusedElement)) {
                            if (ArrayOfLi[i].parentElement.classList[0] === 'menu-optinalcta') {
                                flag = true;
                            } else {
                                this.helpLength = 0;
                                if (i === 0) {
                                    i = 1;
                                }

                                ArrayOfLiText = ArrayOfLi[i - 1].children[1].innerHTML.substring(0, ArrayOfLi[i - 1].children[1].innerHTML.indexOf('<'))
                                if ((ArrayOfLiText.toString()).replace(/\s+/g, '') == this.optionRepeat[x].values[y].value.replace(/\s+/g, '')) {
                                    flag = true;
                                }
                            }
                        }
                    }
                }
            } else {
                // Match each item of array of Li with currentSelected to check if any item is selected previously or not
                // for normal and group type

                // add case where defaultText attribute is used (special type of dropdown that doesn't show default value in option list)
                if (ArrayOfLi[i].innerText.replace(/\s+/g, ' ').trim() === this.focusedElement.replace(/\s+/g, ' ').trim()
                    || ('Select' === this.focusedElement.replace(/\s+/g, ' ').trim())
                    || this.defaultText === this.focusedElement.replace(/\s+/g, ' ').trim()) {
                    flag = true;
                }
            }

            if (flag === true) {
                if (this.type !== 'group') {
                    let flag1 = true;
                    if (this.type === 'image-icons' || this.type === 'no-image-icons' || (this.type == 'normal' && this.helpTextOption)) {
                        // To check the item is not the first item
                        if (ArrayOfLi[i].attributes.attrindex.value === '0') {
                            flag1 = false;
                        }
                    } else {
                        // add case where defaultText attribute is used
                        // (special type of dropdown that doesn't show default value in option list)
                        if (ArrayOfLi[i].attributes.attrindex.value === '0') {
                            flag1 = false;
                        }
                    }
                    // if not the first item of the list
                    if (flag1) {
                        if (this.ctaOption != null) {
                            if (this.focusedElement === this.ctaOption.innerText) {
                                this.previousElement = ArrayOfLi[i - 1];
                            }
                        }
                        if (this.optgrpType === 'true' && i == this.optionRepeat.length - 1 && splCase) {
                            i = this.optionRepeat.length;
                        }
                        // update the list item index for new selection
                        let liSelected = ArrayOfLi[i - 1];
                        this.previousElement = ArrayOfLi[i];
                        if (this.checkDisable(ArrayOfLi[i - 1])) {
                            liSelected = ArrayOfLi[i];
                        }
                        // if the item is disabled update the index till we find any non disabled value
                        for (let j = 0; j < i; j++) {
                            if (!this.checkDisable(ArrayOfLi[j])) {
                                liSelected = ArrayOfLi[j]
                            }
                        }

                        liSelected.focus();
                        this.previousElement = liSelected.innerText;
                        if (!this.toggleFlag) {
                            if (this.currentSelected.text === 'Select') {
                                this.currentSelected = this.optionRepeat[this.optionRepeat.length - 1];
                            } else {
                                if (this.optionRepeat[i - 1].disabled) {
                                    for (let j = 0; j < i; j++) {
                                        if (!this.checkDisable(ArrayOfLi[j])) {
                                            this.currentSelected = this.optionRepeat[j];
                                        }
                                    }
                                } else {
                                    this.currentSelected = this.optionRepeat[i - 1];
                                }
                                if (this.type === 'image-icons' ||
                                    this.type === 'no-image-icons' ||
                                    (this.type === 'normal' && this.helpTextOption) ||
                                    (this.type === 'group' && this.optgrpType)) {
                                    this.element.nativeElement.querySelector('button').focus();
                                } else {
                                    this.element.nativeElement.querySelector('input').focus();
                                }
                            }
                            this.previousElement = this.currentSelected.text;
                            if (this.currentSelected.helpText !== undefined) {
                                this.spanObj = this.currentSelected.helpText;
                                this.currentSelectedHelpText = this.spanObj.split(',');
                            }
                            if (!this.optionRepeat[i - 1].disabled) {
                                this.dropdownValueChange.emit(this.currentSelected);
                            }
                            if (this.type === 'image-icons' || this.type === 'no-image-icons' ||
                                (this.type === 'normal' && this.helpTextOption) ||
                                (this.type === 'group' && this.optgrpType)) {
                                this.element.nativeElement.querySelector('button').focus();
                            } else {
                                this.element.nativeElement.querySelector('input').focus();
                            }
                        }
                        return;
                    }
                    if (!flag1) {
                        i = 1;
                        while(ArrayOfLi[i-1].attributes.getNamedItem('disabled').value === 'disabled'){
                            i++;
                        }
                        // update the list item index for new selection
                        let liSelected = ArrayOfLi[i - 1];
                        // if the item is disabled update the index till we find any non disabled value
                        while (this.checkDisable(ArrayOfLi[i - 1])) {
                            if (i - 1 == 0) {
                                break;
                            }
                            if (ArrayOfLi[i - 1]) {
                                i--;
                            }
                            liSelected = ArrayOfLi[i - 1];
                        }
                        this.previousElement = ArrayOfLi[i]
                        liSelected.focus();
                        this.previousElement = liSelected.innerText;
                        if (!this.toggleFlag) {
                            this.currentSelected = this.optionRepeat[i - 1];
                            this.previousElement = this.currentSelected.text;
                            if (this.currentSelected.helpText !== undefined) {
                                this.spanObj = this.currentSelected.helpText;
                                this.currentSelectedHelpText = this.spanObj.split(',');
                            }
                            if (!this.optionRepeat[i - 1].disabled) {
                                this.dropdownValueChange.emit(this.currentSelected);
                                if (this.type === 'image-icons' || this.type === 'no-image-icons' ||
                                    (this.type === 'normal' && this.helpTextOption) ||
                                    (this.type === 'group' && this.optgrpType)) {
                                    this.element.nativeElement.querySelector('button').focus();
                                } else {
                                    this.element.nativeElement.querySelector('input').focus();
                                }
                            }
                        }
                        return;

                    }
                } else if (this.type === 'group' && !this.optgrpType) {
                    // to verify that item is not the first item of first group
                    if (ArrayOfLi[i].innerText.replace(/\s+/g, ' ').trim() !== this.optionRepeat[0].values[0].text) {
                        // update the new value to be selected
                        let liSelected = ArrayOfLi[i - 1];
                        this.previousElement = ArrayOfLi[i];
                        liSelected.focus();
                        this.previousElement = liSelected.innerText.replace(/\s+/g, ' ').trim();
                        if (!this.toggleFlag) {
                            for (let k = 0; k < this.optionRepeat.length; k++) {
                                for (let j = 0; j < this.optionRepeat[k].values.length; j++) {
                                    if (liSelected.innerText.replace(/\s+/g, ' ').trim() === this.optionRepeat[k].values[j].text) {
                                        if (this.currentSelected.text === 'Select') {
                                            this.currentSelected = this.optionRepeat[0].values[0];
                                        } else {
                                            this.currentSelected = this.optionRepeat[k].values[j];
                                        }

                                        this.previousElement = this.currentSelected.text;
                                        if (!this.optionRepeat[k].values[j].disabled) {
                                            this.dropdownValueChange.emit(this.currentSelected);
                                            this.element.nativeElement.querySelector('input').focus();
                                        }
                                    }
                                }
                            }
                        }
                        return;
                    } else if (ArrayOfLi[i].innerText.replace(/\s+/g, ' ').trim() === this.optionRepeat[0].values[0].text) {
                        // update the new value to be selected
                        this.previousElement = ArrayOfLi[i];
                        i = 1;
                        var liSelected = ArrayOfLi[i - 1];
                        liSelected.focus();
                        this.previousElement = liSelected.innerText.replace(/\s+/g, ' ').trim();
                        if (!this.toggleFlag) {
                            for (let k = 0; k < this.optionRepeat.length; k++) {
                                for (let j = 0; j < this.optionRepeat[k].values.length; j++) {
                                    if (liSelected.innerText.replace(/\s+/g, ' ').trim() === this.optionRepeat[k].values[j].text) {
                                        this.currentSelected = this.optionRepeat[k].values[j];
                                        this.previousElement = this.currentSelected.text;
                                        if (!this.optionRepeat[k].values[j].disabled) {
                                            this.dropdownValueChange.emit(this.currentSelected);
                                            this.element.nativeElement.querySelector('input').focus();
                                        }
                                    }
                                }
                            }
                        }
                        return;
                    }

                } else if (this.type === 'group' && this.optgrpType) {
                    let length = 0;
                    let noOfSpan = 0;
                    for (let count = 0; count < ArrayOfLi[i - 1].querySelectorAll('span').length; count++) {
                        if (count === 0) {
                            continue;
                        }
                        length = length + ArrayOfLi[i - 1].querySelectorAll('span')[count].innerText.length;
                        noOfSpan++;
                    }
                    if (ArrayOfLi[i].parentElement.classList[0] == 'menu-optinalcta') {
                        var ArrayOfLiText = ArrayOfLi[i - 1].querySelectorAll('span')[0].innerText.substring(0, ArrayOfLi[i - 1].querySelectorAll('span')[0].innerText.length - length - noOfSpan);
                    } else {
                        var ArrayOfLiText = ArrayOfLi[i - 1].querySelectorAll('span')[0].innerText.substring(0, ArrayOfLi[i - 1].querySelectorAll('span')[0].innerText.length - this.helpLength);
                    }

                    if (ArrayOfLiText !== this.optionRepeat[0].values[0].text) {
                        let liSelected = ArrayOfLi[i - 1];
                        this.previousElement = ArrayOfLi[i];
                        liSelected.focus();
                        this.previousElement = liSelected.innerText;
                        if (!this.toggleFlag) {
                            for (let k = 0; k < this.optionRepeat.length; k++) {
                                for (let j = 0; j < this.optionRepeat[k].values.length; j++) {
                                    let length = 0
                                    for (let count = 0; count < liSelected.querySelectorAll('span').length; count++) {
                                        if (count === 0) {
                                            continue
                                        }
                                        length = length + liSelected.querySelectorAll('span')[count].innerText.length;
                                    }
                                    let liSelectedText = liSelected.querySelectorAll('span')[0].innerText.substring(0, liSelected.querySelectorAll('span')[0].innerText.length - length);
                                    if (liSelectedText == this.optionRepeat[k].values[j].text) {
                                        this.currentSelected = this.optionRepeat[k].values[j];
                                        this.previousElement = this.currentSelected.text;
                                        if (!this.optionRepeat[k].values[j].disabled) {
                                            this.dropdownValueChange.emit(this.currentSelected);
                                            this.element.nativeElement.querySelector('button').focus();
                                        }
                                    }
                                }
                            }
                        }
                        return;
                    } else if (ArrayOfLiText == this.optionRepeat[0].values[0].text) {
                        this.previousElement = ArrayOfLi[i];
                        i = 1;
                        var liSelected = ArrayOfLi[i - 1];

                        liSelected.focus();
                        this.previousElement = liSelected.innerText;
                        if (!this.toggleFlag && liSelected.querySelectorAll('span').length > 0) {
                            for (let k = 0; k < this.optionRepeat.length; k++) {
                                for (let j = 0; j < this.optionRepeat[k].values.length; j++) {
                                    let length = 0
                                    for (var count = 0; count < liSelected.querySelectorAll('span').length; count++) {
                                        if (count == 0) {
                                            continue
                                        }
                                        length = length + liSelected.querySelectorAll('span')[count].innerText.length;
                                    }
                                    var liSelectedText = liSelected.querySelectorAll('span')[0].innerText.substring(0, liSelected.querySelectorAll('span')[0].innerText.length - length);
                                    if (liSelectedText == this.optionRepeat[k].values[j].text) {
                                        this.currentSelected = this.optionRepeat[k].values[j];
                                        this.previousElement = this.currentSelected.text;
                                        if (!this.optionRepeat[k].values[j].disabled) {
                                            this.dropdownValueChange.emit(this.currentSelected);
                                            this.element.nativeElement.querySelector('button').focus();
                                        }
                                    }
                                }
                            }
                        }
                        return;
                    }
                }
            }
        }
    }
    public scrollToView(targetElem, additionalPadding) {
        let scrollTOPTarget = targetElem.getBoundingClientRect().top + targetElem.offsetHeight - window.innerHeight + 2;
        if (scrollTOPTarget > 0) {
            document.querySelectorAll('body')[0].scrollTop = window.pageYOffset + scrollTOPTarget + additionalPadding;
            document.querySelectorAll('html')[0].scrollTop = window.pageYOffset + scrollTOPTarget + additionalPadding;
        }
    }
    public scrollToViewVertical(targetElem) {
        if (targetElem) {
            var wrapperWidth = targetElem.offsetWidth;
            var left = targetElem.getBoundingClientRect().left;
            if ((this.docWidth < (wrapperWidth + left))) {
                // when selector menu open out of viewport
                let targetLeft = wrapperWidth + left - this.docWidth + 15;
                this.fixUpCSS(targetElem.parentElement, { 'left': -targetLeft + 'px' })
                this.appendCaretPositionStyle(Math.abs(targetLeft));
            };
            if (left < 0) {
                this.fixUpCSS(targetElem.parentElement, { 'left': 0 + 'px' })
                this.appendCaretPositionStyle(Math.abs((0)));
            };
        }
    }
    public appendCaretPositionStyle(leftCheck) {
        while (document.querySelector('style#ddhDropdownCaret')) {
            document.querySelector('style#ddhDropdownCaret').remove();
        };
        var caretPosition = this.element.nativeElement.children[0].children[0].clientWidth - 24;
        var afterCaretPosition = caretPosition - 2;
        if (leftCheck !== undefined) {
            caretPosition = caretPosition + leftCheck;
            afterCaretPosition = afterCaretPosition + leftCheck;
        }
        var styleElement = document.createElement('style');
        styleElement.id = 'ddhDropdownCaret';
        styleElement.type = 'text/css'
        styleElement.innerHTML = ' .linkSelectionMenu .active+.menuWrapper:before{left:' + caretPosition +
            'px;} .linkSelectionMenu .active+.menuWrapper:after{left:' + afterCaretPosition + 'px';
        var template = styleElement
        document.querySelector('head').appendChild(template);

    };

    public searchElement(searchExp) {
        this.searchResult = [];
        this.searchString = '';
        for (var i = 0; i < searchExp.length; i++) {
            this.searchString = this.searchString + String.fromCharCode(searchExp[i]);
        }
        if (this.type != 'group') {
            for (var j = 0; j < this.optionRepeat.length; j++) {
                if (this.optionRepeat[j].text.toUpperCase().startsWith(this.searchString.toUpperCase())) {
                    this.searchResult.push(j);
                }
            }
        }
        if (this.type == 'group') {
            for (var a = 0; a < this.optionRepeat.length; a++) {
                for (var b = 0; b < this.optionRepeat[a].values.length; b++) {
                    if (this.optionRepeat[a].values[b].text.toUpperCase().startsWith(this.searchString.toUpperCase())) {
                        this.searchResult.push((a * this.optionRepeat[a].values.length) + b);
                    }
                }
            }
        }
    };
    startTimer(time) {
        var instance = this;
        setTimeout(function() {
            instance.searchStringCode = [];
        }, time);
    };
    updateTouch() {
        this.flagTouched.emit(true);
    }
    public fixUpCSS(element, cssObject) {
        for (var key in cssObject) {
            element.style[key] = cssObject[key];
        };
    };
}
